import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../styles/helpers/flexbox';

const SearchContainer = styled.div`
  ${flexbox()}

  .clear {
    padding: 0px 0px 0px 10px;
    align-self: flex-end;
  }
`;

const SearchableListWrapper = styled.div((props) => {
  const { colours, typography } = props.theme;

  return `   
        ${flexbox()}
        border: 1px solid ${colours.grey[400]};
        border-radius: 5px;
        height: 34px;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;
        margin-top: 2px;
       
        .searchText {
          width: 92%;
          margin: auto 4px;
        }
        
        .searchLogo {
          width: 8%;
          height: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          
          [class*="svgIconComponent"] {
              width: 18px;

              * {
                fill: $colour-white !important;
              }
          }
        }
      `;
});

const InputWrapper = styled.input((props) => {
  const { typography } = props.theme;

  return ` 
        height: 25px;
        border: none;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;
        padding-left: 4px;
        width: 97%;

        &::-webkit-input-placeholder {
            color: lightgray;
            font-weight: 600;
        }

        &:-ms-input-placeholder {
            color: lightgray;
            font-weight: 600;
        }
    `;
});

const SelectPanelWrapper = styled.div((props) => {
  const { colours, typography } = props.theme;

  return `  
    ${flexbox()}
    ${flexDirection('column')}
    z-index: 10;
    position: absolute; 
    background-color: white;
    width: 480px;
    height: 400px;
    border: 1px solid ${colours.grey[200]};
    border-top: none;

    @media(max-width: 1100px) {
      width: 400px;
    }
    
    .panelFooter {
       ${flexbox()}
       ${alignItems('center')}
       ${justifyContent('space-between')}
       
       height: 60px;
       background: #cfd2d4;
       width: 100%;
       
       .uncheck {
         margin-left: 10px;
       }
       
       .apply {
         margin-right: 10px;
       }
    }

    .panelBody {
       height: 340px;
       overflow-y: scroll;
       
       .strand {
         padding: 10px;
         
         .wrapper {
           ${flexbox()}
           
           .Description {
             width: 96%;
           }
           
           .icon {
              cursor: pointer;
           }
         }
         
         svg {
          path {
            fill: ${colours.grey[700]} !important;
          }
         }
         
         [class*="svgIconComponent"] {
                   width: 16px;
         }
       }
       
        .line {
           width: 95%;
           border-top: 2px solid ${colours.grey[400]};
         }
       
       .spacer {
        padding-left: 15px;
       }
    }
    
     .unCheckAllButton {
      width: max-content;
      height: 30px;
      font-family: ${typography.family};
      font-size: 14px;
      font-weight: 600;
      :hover {
        filter: none;
      }
     }
     
     .applyButton {
      width: max-content;
      height: 30px;
      :hover {
        filter: none;
      }
     }
    `;
});

const TopicHeader = styled.div(() => {
  return ` 
        margin-top: 6px;
        margin-left: 15px;
        font-weight: bold;
        font-size: 14px;

       .spanTopicDiff{
        float: right;
        margin-right: 93px;
     }
    `;
});

const showElement = (bool) => ({
  display: bool ? '' : 'none'
});

const FilterWrapper = styled.div`
  ${flexDirection('column')}
  font-size: 11px
  width: 100%;
`;

const FilteredListWrapper = styled.span((props) => {
  const { colours } = props.theme;
  return `
    path {
      fill: ${colours.grey[600]} !important;
    }
  `;
});

export {
  SearchableListWrapper,
  InputWrapper,
  SelectPanelWrapper,
  showElement,
  SearchContainer,
  FilterWrapper,
  FilteredListWrapper,
  TopicHeader
};



// WEBPACK FOOTER //
// ./components/filter-dropdownlist/styled.js